var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowDefColor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "7px",
    viewBox: "0 0 12 7",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "left") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDF3BTest-v2---Lucie",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Commandes->-listes-(Mesa)",
    transform: "translate(-1055.000000, -167.000000)",
    fill: "#960000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "left",
    transform: "translate(1060.955000, 170.275000) scale(-1, 1) rotate(90.000000) translate(-1060.955000, -170.275000) translate(1058.000000, 165.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "5.26271429 0 0.309571429 4.95146667 0 5.275 0.309571429 5.59853333 5.26271429 10.55 5.91 9.90293333 1.2805 5.275 5.91 0.647066667"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDefColor);
export default __webpack_public_path__ + "static/media/arrow-def-color.d953891b04b127ac279b5ea8ab9b0c4c.svg";
export { ForwardRef as ReactComponent };